/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=330a1698&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=330a1698&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\shujukeshihuaqianduan\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330a1698"]])

export default __exports__